/* eslint @typescript-eslint/unbound-method: "off" */
import {
  compose,
  cond,
  curry,
  is,
  join,
  map,
  partial,
  T,
  tap,
  unless
} from 'ramda';

import { arrayify } from './arrays';

/**
 * Simple formatter for logging - replaces pretty-format dependency.
 * Formats values as JSON with 2-space indentation for readability.
 */
const simpleFormat = cond([
  [is(String), (x) => x],
  [is(Function), (x) => `[Function: ${x.name || 'anonymous'}]`],
  [(x) => x instanceof Error, (x) => `${x.name}: ${x.message}`],
  [T, (x) => {
    try {
      return JSON.stringify(x, null, 2);
    }
    catch {
      return String(x);
    }
  }]
]);

export const trace = (...args) => tap(partial(console.log, args));

export const makeGenericMessage = curry(
  (type, context, message, inline = true) => {
    const maybePretty = unless(is(String), simpleFormat);
    const breakValue = inline ? ' ' : '\n\n';
    const formatContext = compose(join(' > '), arrayify);
    const formatMessage = compose(join(breakValue), map(maybePretty), arrayify);

    return `${type} (${formatContext(context)}):${breakValue}${formatMessage(message)}`;
  }
);

export const makeError = makeGenericMessage('ERROR');
export const makeInfo = makeGenericMessage('INFO');
export const makeWarn = makeGenericMessage('WARNING');
